import restRequestV3 from '@/utils/restRequestV3'

const BASE_URL = '/api/v3/short-link'

export default {
  /**
   * 获取短链接列表
   * @param {Object} params 查询参数
   * @param {number} params.pageNum 页码
   * @param {number} params.pageSize 每页数量
   * @param {string} [params.keyword] 搜索关键词
   * @returns {Promise<PageVO<ShortLink>>} 短链接列表数据
   * @returns {ShortLink[]} response.records 短链接记录
   * @returns {number} response.total 总记录数
   */
  getShortLinkList(params) {
    return restRequestV3.get(`${BASE_URL}/list`, params)
  },

  /**
   * 创建或获取短链接
   * @param {Object} data 短链接数据
   * @param {string} data.originalUrl 原始URL
   * @param {string} data.path 短链访问路径
   * @param {string} [data.linkType] 短链接类型
   * @param {string} [data.nfcChipId] NFC芯片ID
   * @returns {Promise<ShortLink>} 短链接数据（新建或已存在的）
   */
  createOrGetShortLink(data) {
    return restRequestV3.post(`${BASE_URL}/create-or-get`, data)
  },

  /**
   * 创建短链接
   * @param {Object} data 短链接数据
   * @param {string} data.originalUrl 原始URL
   * @param {string} [data.linkType] 短链接类型
   * @param {string} [data.nfcChipId] NFC芯片ID
   * @returns {Promise<ShortLink>} 创建的短链接数据
   */
  createShortLink(data) {
    return restRequestV3.post(`${BASE_URL}/create`, data)
  },

  /**
   * 更新短链接
   * @param {Object} data 更新数据
   * @param {number} data.shortLinkId 短链接ID
   * @param {string} data.originalUrl 原始URL
   * @param {string} [data.linkType] 短链接类型
   * @param {string} [data.nfcChipId] NFC芯片ID
   * @param {number} [data.status] 状态(0-停用,1-启用)
   * @returns {Promise<ShortLink>} 更新后的短链接数据
   */
  updateShortLink(data) {
    return restRequestV3.post(`${BASE_URL}/update`, data)
  },

  /**
   * 删除短链接
   * @param {Object} data 删除参数
   * @param {number} data.shortLinkId 短链接ID
   * @returns {Promise<void>}
   */
  deleteShortLink(data) {
    return restRequestV3.post(`${BASE_URL}/delete`, data)
  },

  /**
   * 生成短链接二维码
   * @param {string} code 短链码
   * @param {Object} params 二维码参数
   * @param {number} [params.width=300] 宽度
   * @param {number} [params.height=300] 高度
   * @returns {Promise<{qrCodeUrl: string, shortUrl: string}>} 二维码信息
   */
  generateQRCode(code, params) {
    return restRequestV3.get(`${BASE_URL}/qrcode/${code}`, params)
  },

  /**
   * 生成短链接小程序码
   * @param {string} code 短链码
   * @param {Object} params 小程序码参数
   * @param {number} [params.width=300] 宽度
   * @param {string} [params.scene] 场景值
   * @param {string} [params.page] 页面路径
   * @returns {Promise<{wxaCodeUrl: string, shortUrl: string}>} 小程序码信息
   */
  generateWxaCode(code, params) {
    return restRequestV3.get(`${BASE_URL}/wxacode/${code}`, params)
  },

  // 访问短链接
  visitShortLink(code, isShare = false) {
    const params = isShare ? { isShare: true } : {}
    return restRequestV3.get(`${BASE_URL}/visit/${code}`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/v3/shortLink.js